export enum DateInterval {
  Day,
  Week,
  Month,
  Half,
  Last3Hours,
  Last6Hours,
  Last12Hours,
  Today,
  Yesterday
}